export default __webpack_public_path__ + "static/media/upper-case.0fbe0cdd.svg";